module.exports = __webpack_public_path__ + "static/media/bpmeasurex-charger-2.92137b2b.png";